import { render, staticRenderFns } from "./GetCustomerConsumptionsSubComponent.vue?vue&type=template&id=3acb0452&scoped=true&"
import script from "./GetCustomerConsumptionsSubComponent.vue?vue&type=script&lang=js&"
export * from "./GetCustomerConsumptionsSubComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acb0452",
  null
  
)

export default component.exports